module.exports = __webpack_public_path__ + "img/4.b0cb1db3.png";